var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 50,
    viewBox: "0 0 96 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 94,
    height: 48,
    rx: 4,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7479 24.2929C16.3574 24.6834 16.3574 25.3166 16.7479 25.7071L23.1118 32.0711C23.5024 32.4616 24.1355 32.4616 24.5261 32.0711C24.9166 31.6805 24.9166 31.0474 24.5261 30.6569L18.8692 25L24.5261 19.3431C24.9166 18.9526 24.9166 18.3195 24.5261 17.9289C24.1355 17.5384 23.5024 17.5384 23.1118 17.9289L16.7479 24.2929ZM78.5459 24L17.455 24V26L78.5459 26V24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.da928ee7753cadcce8e57b808914a391.svg";
export { ForwardRef as ReactComponent };